import styled, { DefaultTheme, keyframes } from 'styled-components';

// Loader animation
const backgroundColorAnim = (theme: DefaultTheme) => keyframes`
  0% { 
    background-color: ${theme.colors.primary};
  }
  45% { 
    background-color ${theme.colors.primary};
  }
  50% { 
    background-color ${theme.colors.grey4};
  }
  95% { 
    background-color ${theme.colors.grey4};
  }
  100% { 
    background-color ${theme.colors.primary};
  }
`;

// Types
type RootProps = {
  size: 'small' | 'medium' | 'large';
  $center: boolean;
  $padding: boolean;
};

type LoadingDotProps = {
  $index: number;
  size: 'small' | 'medium' | 'large';
};

// Variables
const dotSizePercentage = 20;
const bottomAndTopMargin = dotSizePercentage / 6;
const positions = [
  {
    top: bottomAndTopMargin,
    right: (100 - 3 * dotSizePercentage) / 2,
  },
  {
    top: 50,
    right: 0,
    transform: 'translate(0%, -50%)',
  },
  {
    bottom: bottomAndTopMargin,
    right: (100 - 3 * dotSizePercentage) / 2,
  },
  {
    bottom: bottomAndTopMargin,
    left: (100 - 3 * dotSizePercentage) / 2,
  },
  {
    top: 50,
    left: 0,
    transform: 'translate(0%, -50%)',
  },
  {
    top: bottomAndTopMargin,
    left: (100 - 3 * dotSizePercentage) / 2,
  },
];

const sizeMap = {
  small: '25px',
  medium: '45px',
  large: '55px',
};

export const Root = styled.div<RootProps>`
  position: relative;
  width: ${({ size }) => sizeMap[size]};
  height: ${({ size }) => sizeMap[size]};
  margin: ${({ $center, $padding }) => {
    if ($center && $padding) {
      return '32px auto';
    }
    if ($center) {
      return '0 auto';
    }
    if ($padding) {
      return '32px 0';
    }
    return 'none';
  }};
`;

export const LoadingDot = styled.div<LoadingDotProps>`
  position: absolute;
  border-radius: 50%;
  width: ${dotSizePercentage}%;
  height: ${dotSizePercentage}%;
  background-color: ${({ theme }) => theme.colors.grey4};
  animation-delay: ${({ $index }) => $index * 0.15}s;
  top: ${({ $index }) => positions[$index].top}%;
  bottom: ${({ $index }) => positions[$index].bottom}%;
  left: ${({ $index }) => positions[$index].left}%;
  right: ${({ $index }) => positions[$index].right}%;
  transform: ${({ $index }) => positions[$index].transform};
  animation-name: ${({ theme }) => backgroundColorAnim(theme)};
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
`;
